var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF4D03;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.3,149.3c-11.8,0-21.3,9.6-21.3,21.3v238.7c-1.3,22.5-20.4,39.7-42.9,38.6H170.9 c-22.5,1.1-41.6-16.1-42.9-38.6V170.7c0-11.8-9.6-21.3-21.3-21.3s-21.3,9.6-21.3,21.3v238.7c1.3,46,39.5,82.4,85.5,81.3h170.2 c46,1.1,84.3-35.2,85.5-81.3V170.7C426.7,158.9,417.1,149.3,405.3,149.3z M426.7,85.3h-85.3V42.7c0-11.8-9.6-21.3-21.3-21.3H192 c-11.8,0-21.3,9.6-21.3,21.3v42.7H85.3c-11.8,0-21.3,9.6-21.3,21.3S73.6,128,85.3,128h341.3c11.8,0,21.3-9.6,21.3-21.3 S438.4,85.3,426.7,85.3z M213.3,85.3V64h85.3v21.3H213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.7,362.7V213.3c0-11.8-9.6-21.3-21.3-21.3c-11.8,0-21.3,9.6-21.3,21.3v149.3c0,11.8,9.6,21.3,21.3,21.3 C225.1,384,234.7,374.4,234.7,362.7z M320,362.7V213.3c0-11.8-9.6-21.3-21.3-21.3c-11.8,0-21.3,9.6-21.3,21.3v149.3 c0,11.8,9.6,21.3,21.3,21.3C310.4,384,320,374.4,320,362.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d454f154567fd915a67e4ef9b11eca4c.svg";
export { ForwardRef as ReactComponent };